export class HoAcceptMessages {
  static readonly ACCEPT_HO_SUCCESS_INI = 'El Handover';
  static readonly ACCEPT_HO_SUCCESS_END = 'se aceptó exitosamente.';
  static readonly ACCEPT_HO_ERROR_INI =
    'Hubo un problema y el Handover no pudo ser aceptado.';
  static readonly ACCEPT_HO_ERROR_END = 'Por favor, inténtelo nuevamente.';
  static readonly SUCCESS_NOTIFICATION = true;
  static readonly ERROR_NOTIFICATION = false;
}

export class HoRejectMessages {
  static readonly REJECT_HO_SUCCESS_INI = 'El Handover';
  static readonly REJECT_HO_SUCCESS_END = 'se rechazó exitosamente.';
  static readonly REJECT_HO_ERROR_INI =
    'Hubo un problema y el Handover no pudo ser rechazado.';
  static readonly REJECT_HO_ERROR_END = 'Por favor, inténtelo nuevamente.';
  static readonly SUCCESS_NOTIFICATION = true;
  static readonly ERROR_NOTIFICATION = false;
}
